import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-thankyou',
  templateUrl: './thankyou.component.html',
  styleUrls: ['./thankyou.component.scss'],
})
export class ThankyouComponent implements OnInit {
  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {}

  restartJourney() {
    if (sessionStorage.getItem('journey')) {
      this.router.navigate(['start/' + sessionStorage.getItem('journey')])
    }
    else {
      this.router.navigate(['/departments']);
    }
  }
}
